import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {CodeSelectPage} from './code-select.page';

const routes: Routes = [
  {
    path: '',
    component: CodeSelectPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CodeSelectPageRoutingModule {}
